import { get } from 'lodash';
import formatShortDate from 'common/utils/Dates/formatShortDate';

const parseRelationships = (relationships = {}) => Object.entries(relationships).reduce((acc, [key, value]) => ({
  ...acc,
  [key]: value?.data,
}), {});

export const getPersonData = (data, authorization, includeInternalNonConsentedClients) => {
  if (includeInternalNonConsentedClients) {
    const [includedPerson] = get(data, 'data.included', []);
    return includedPerson ? {
      id: includedPerson.id,
      ...includedPerson.attributes,
      ...parseRelationships(includedPerson.relationships),
    } : {};
  }
  return get(authorization, 'person', {});
};

export const getDisplayDates = (authorization) => {
  const dateRequestedStartsAt = formatShortDate(authorization.requested_starts_at);
  const dateRequestedEndsAt = formatShortDate(authorization.requested_ends_at);
  const isSingleDateRequested = authorization.requested_starts_at === authorization.requested_ends_at;

  return {
    dateRequestedStartsAt,
    dateRequestedEndsAt,
    isSingleDateRequested,
  };
};

export const hasRequestedOrInReviewEdition = (serviceAuthorization) => {
  const lineage = serviceAuthorization.lineage || [];
  const isSingleSelfLineage = lineage.length === 1 && lineage[0].id === serviceAuthorization.id;

  if (isSingleSelfLineage) return false;

  return lineage.some((auth) => (auth.state === 'requested' || auth.state === 'in_review'));
};
